<template>
    <b-container fluid>
      <b-row>
        <b-col lg="12">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Web3 Wallet</h4>
            </template>
            <template v-slot:default>
                <div class="text-center mt-2">
                <h5 class="mb-4">Export Private Key</h5>
                <p>Never disclose this key. Anyone with your private key can steal assets held in your account.</p>
                <img src="../../assets/images/onboarding-welcome-decentralised-apps.svg" alt="">
                <form>
             <b-row>
                <b-col lg="12">
          <Form @submit="exportPrivateKey" v-slot="{ errors }" :validation-schema="rules">
          <div class="form-group">
          <label for="password">Password</label>
          <Field name="password" class="form-control mb-0 password" :class="{ 'is-invalid': errors['password']}"
             id="password"/>
          </div>
          <button class="btn btn-primary mt-2">Export private key</button>
          </Form>
          </b-col>
          </b-row>
          </form>
          <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary mt-3" v-if="exportResult">
            <div class="iq-alert-text">{{ exportResult }}</div>
            </div>
          </div>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
  </template>
<script>
import IqCard from '../../components/xray/cards/iq-card'
import { xray } from '../../config/pluginInit'
import firebase from '../../../firebase'
import web3Service from '../../services/web3/web3Service'
import { ref } from 'vue'
import { Field, Form } from 'vee-validate'
import * as yup from 'yup'

const body = document.getElementsByTagName('body')

export default {
  name: 'ShopSessions',
  components: { IqCard, Form, Field },
  setup () {
    const { exportWallet } = web3Service()
    const currentUser = firebase.firebaseAuth.currentUser
    const exportResult = ref(null)

    const exportPrivateKey = async (form, { resetForm }) => {
      exportResult.value = null
      try {
        const privateKey = await exportWallet(currentUser.uid, form.password)
        await navigator.clipboard.writeText(privateKey)
        resetForm()
        exportResult.value = 'Privated key copied to clipboard.'
      } catch (e) {
        exportResult.value = e
      }
    }

    const rules = yup.object().shape({
      password: yup.string().required()
    })

    return {
      exportPrivateKey,
      rules,
      exportResult
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

  <style>
    .password {
        width: 300px !important;
        margin: auto !important;
    }
  </style>
